// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/EnterpriseSoftwareDevelopment","imageWrapper":"EnterpriseSoftwareDevelopment-m__imageWrapper__f52bc32kS1l"};